'use client'

import { useEffect, useCallback, useRef } from 'react'
import confetti from 'canvas-confetti'

// Check if mobile device
function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false
  return window.innerWidth < 768 ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// Confetti no sucesso final
export function useSuccessConfetti() {
  const isMobileRef = useRef(false)

  useEffect(() => {
    isMobileRef.current = isMobileDevice()
  }, [])

  const triggerConfetti = useCallback(() => {
    const isMobile = isMobileRef.current
    // Reduced duration and particles on mobile
    const duration = isMobile ? 1500 : 3000
    const animationEnd = Date.now() + duration
    const defaults = {
      startVelocity: isMobile ? 20 : 30,
      spread: 360,
      ticks: isMobile ? 40 : 60,
      zIndex: 100
    }

    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min
    }

    // Less frequent intervals on mobile
    const intervalMs = isMobile ? 500 : 250

    const interval = setInterval(function () {
      const timeLeft = animationEnd - Date.now()

      if (timeLeft <= 0) {
        return clearInterval(interval)
      }

      // Reduced particles on mobile (15 vs 50)
      const baseCount = isMobile ? 15 : 50
      const particleCount = baseCount * (timeLeft / duration)

      // Confetti dos dois lados (single side on mobile)
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        colors: ['#8b5cf6', '#d946ef', '#22c55e', '#facc15']
      })

      // Skip second confetti on mobile for performance
      if (!isMobile) {
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
          colors: ['#8b5cf6', '#d946ef', '#22c55e', '#facc15']
        })
      }
    }, intervalMs)

    return () => clearInterval(interval)
  }, [])

  return triggerConfetti
}

// Confetti leve para transição de fase
export function usePhaseCelebration() {
  const trigger = useCallback(() => {
    confetti({
      particleCount: 30,
      spread: 50,
      origin: { y: 0.6 },
      colors: ['#8b5cf6', '#d946ef'],
      disableForReducedMotion: true
    })
  }, [])

  return trigger
}

// Componente que dispara confetti automaticamente no mount
export function SuccessConfetti() {
  const triggerConfetti = useSuccessConfetti()

  useEffect(() => {
    // Pequeno delay para garantir que a tela carregou
    const timer = setTimeout(() => {
      triggerConfetti()
    }, 300)

    return () => clearTimeout(timer)
  }, [triggerConfetti])

  return null // Componente invisível, só dispara o efeito
}

// Micro-celebração para validação de campo
export function triggerFieldSuccess() {
  confetti({
    particleCount: 10,
    spread: 30,
    startVelocity: 20,
    origin: { x: 0.5, y: 0.7 },
    colors: ['#22c55e'],
    scalar: 0.8,
    disableForReducedMotion: true
  })
}

// Celebração de step importante (contato preenchido, etc)
export function triggerMilestoneConfetti() {
  const count = 20
  const defaults = {
    origin: { y: 0.7 },
    disableForReducedMotion: true
  }

  function fire(particleRatio: number, opts: confetti.Options) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    })
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    colors: ['#8b5cf6']
  })
  fire(0.2, {
    spread: 60,
    colors: ['#d946ef']
  })
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
    colors: ['#22c55e', '#facc15']
  })
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    colors: ['#8b5cf6', '#d946ef']
  })
}
